import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import Help from './Help';

function HelpWrapper(_ref) {
  var classNames = _ref.classNames,
      format = _ref.format,
      children = _ref.children;
  var helpProps = ['emphasised', 'alternative'].indexOf(format) > -1 ? _defineProperty({}, format, true) : {};
  return /*#__PURE__*/React.createElement(Help, _extends({
    classNames: classNames
  }, helpProps), children);
}

HelpWrapper.displayName = "HelpWrapper";
HelpWrapper.propTypes = {
  format: PropTypes.string,
  classNames: PropTypes.string,
  children: PropTypes.node.isRequired
};
HelpWrapper.defaultProps = {
  format: '',
  classNames: ''
};
export default HelpWrapper;